import React from "react";
import { Accordion } from "react-bootstrap";
import PostAccordionItem from "./PostAccordionItem";

/**
 * PostList — accordion wrapper that renders all admin posts.
 *
 * Props:
 *   posts                – array of post objects
 *   bookings             – { [postId]: bookingArray } map
 *   onToggleVisibility   – passed through to each item
 *   onLoadBookings       – passed through to each item
 */
function PostList({ posts, bookings, onToggleVisibility, onLoadBookings, onUpdatePost, onDeletePost }) {
  return (
    <>
      <h2 className="mb-3">Endre Poster</h2>
      <Accordion>
        {posts.map((post) => (
          <PostAccordionItem
            key={post.id}
            post={post}
            bookings={bookings[post.id]}
            onToggleVisibility={onToggleVisibility}
            onLoadBookings={onLoadBookings}
            onUpdatePost={onUpdatePost}
            onDeletePost={onDeletePost}
          />
        ))}
      </Accordion>
    </>
  );
}

export default PostList;
